<template>
  <header class="tool-page-header">
    <div class="tool-page-icon"><img :src="icon" alt="" /></div>
    <div class="tool-page-copy">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    icon: { type: String, required: true }
  }
}
</script>

<style scoped>
.tool-page-header { display: flex; align-items: center; gap: 16px; min-width: 0; margin: 28px 0 0 2%; }
.tool-page-icon { display: grid; place-items: center; flex: 0 0 56px; height: 56px; background: #e9f6ef; border-radius: 16px; }
.tool-page-icon img { width: 40px; height: 40px; object-fit: contain; }
.tool-page-copy { min-width: 0; }
.tool-page-copy h1 { margin: 0 0 4px; color: #24313b; font-size: 26px; line-height: 1.25; }
.tool-page-copy p { margin: 0; color: #89939b; font-size: 14px; }
@media (max-width: 600px) { .tool-page-header { margin-left: 1%; } }
@media (max-width: 480px) { .tool-page-copy h1 { font-size: 22px; } }
</style>
